import React, { useRef, useState } from 'react';
import { IconBox, StyledCategoryButton, StyledCategoryItem, SubMenuContainer } from './styled';

import { Subcategory } from '../Subcategory';
import { useLocation } from 'react-router-dom';

import { MenuLinkItem } from 'components/Menu/NewMenu/subcomponents/MenuLinkItem';
import { iconObj } from 'components/Menu/NewMenu/constants';
//import { makeEnvironmentUrl } from 'utils/development-tools';
import { Tooltip } from 'react-tooltip';

export const CategoryItem = ({
  category: { link, label, isExternal, disabled, children, ...props },
  setIsSubMenuOpen,
  subMenusAreOpen,
  setSubMenusAreOpen,
}) => {
  const index = new Date().getTime();
  const subMenuItems = children;

  const itemRef = useRef(null);
  const location = useLocation();

  const [mainLabel] = useState(label);

  const hasSubmenu = children?.length > 0;

  const handleOpenSubmenu = (mainLabel, children) => {
    setIsSubMenuOpen(!subMenusAreOpen[mainLabel] && children);
    setSubMenusAreOpen(prevSubMenus => ({
      ...Object.fromEntries(Object.keys(prevSubMenus).map(key => [key, false])),
      [mainLabel]: !subMenusAreOpen[mainLabel],
    }));
  };

  const getBasePath = pathname => {
    const segments = pathname.split('/');
    return `/${segments[1]}`;
  };

  const checkIsActive = children => {
    const basePath = getBasePath(location.pathname.toLowerCase());
    return children.some(child => {
      const childLink = child.link ? child.link.toLowerCase() : null;
      return childLink && childLink.includes(basePath.toLowerCase());
    });
  };

  return (
    <StyledCategoryItem
      key={label}
      hasChildren={children}
      disabled={disabled}
      isOpen={subMenusAreOpen[mainLabel]}
      ref={itemRef}
      onClick={() => handleOpenSubmenu(mainLabel, children)}
      {...props}
    >
      {link && (
        <MenuLinkItem label={label} link={link} isExternal={isExternal} isChildren={false} disabled={disabled} />
      )}

      {hasSubmenu && (
        <SubMenuContainer>
          <StyledCategoryButton
            key={label}
            disabled={disabled}
            onClick={event => (disabled ? event.preventDefault() : null)}
            isActive={checkIsActive(children)}
            data-tooltip-id={`menu-${index}-${link}`}
            data-tooltip-content="Você não tem acesso a esse item."
            data-tooltip-place="top-start"
          >
            <IconBox>{iconObj[mainLabel]}</IconBox>
            <span>{label}</span>
          </StyledCategoryButton>
          {disabled && (
            <Tooltip
              id={`menu-${index}-${link}`}
              style={{ borderRadius: 10 }}
              disableTooltip={elem => elem.getAttribute('disabled')}
            />
          )}

          <Subcategory
            mainLabel={mainLabel}
            setIsSubMenuOpen={setIsSubMenuOpen}
            setSubMenusAreOpen={setSubMenusAreOpen}
            onClick={e => e.stopPropagation()}
            subMenuItems={subMenuItems}
          />
        </SubMenuContainer>
      )}
    </StyledCategoryItem>
  );
};
